// extracted by mini-css-extract-plugin
export var active = "_ag-d";
export var blink = "_ag-e";
export var container = "_ag-5";
export var controls = "_ag-0";
export var controlsRight = "_ag-1";
export var fakeCursor = "_ag-c";
export var hidden = "_ag-b";
export var quillContainerSmall = "_ag-7";
export var quillEditor = "_ag-6";
export var quillEditorSmall = "_ag-8";
export var quillFormatButtons = "_ag-a";
export var quillToolbar = "_ag-9";
export var removePadding = "_ag-2";
export var state = "_ag-3";
export var stateTitle = "_ag-4";